import { gql } from "@apollo/client";

export const AddSupplier = gql`
  mutation AddSupplier(
    $token: String!
    $customer_id: ID!
    $supplier_name: String!
    $multi_location: Boolean!
    $includeDeviceType: Boolean
    $input: CreateAtsAcLdgrDetailsInput!
    $user_details: SubscribedUser!
  ) {
    AddSupplier(
      token: $token
      customer_id: $customer_id
      supplier_name: $supplier_name
      multi_location: $multi_location
      includeDeviceType: $includeDeviceType
      input: $input
      user_details: $user_details
    ) {
      id
    }
  }
`;

export const UpdateSupplier = gql`
  mutation UpdateSupplier(
    $token: String!
    $customer_id: ID!
    $supplier_id: ID!
    $user_details: SubscribedUser!
    $includeDeviceType: Boolean
    $input: UpdateSupplierDetails!
  ) {
    UpdateSupplier(
      token: $token
      customer_id: $customer_id
      supplier_id: $supplier_id
      user_details: $user_details
      includeDeviceType: $includeDeviceType
      input: $input
    ) {
      id
    }
  }
`;

export const AddSupplierMultiLocation = gql`
  mutation AddSupplierMultiLocation(
    $token: String!
    $customer_id: ID!
    $supplier_id: ID!
    $user_details: SubscribedUser!
    $input: [CreateAtsAcLdgrMultiLocationInput!]!
  ) {
    AddSupplierMultiLocation(
      token: $token
      customer_id: $customer_id
      supplier_id: $supplier_id
      user_details: $user_details
      input: $input
    )
  }
`;

export const UpdateSupplierMultiLocation = gql`
  mutation UpdateSupplierMultiLocation(
    $token: String!
    $supplier_multi_loc_id: ID!
    $user_details: SubscribedUser!
    $input: UpdateSupplierMultiLocDetails!
  ) {
    UpdateSupplierMultiLocation(
      token: $token
      supplier_multi_loc_id: $supplier_multi_loc_id
      user_details: $user_details
      input: $input
    )
  }
`;

export const DeleteSupplierMultiLocation = gql`
  mutation DeleteSupplierMultiLocation(
    $token: String!
    $supplier_multi_loc_id: ID!
    $user_details: SubscribedUser!
  ) {
    DeleteSupplierMultiLocation(
      token: $token
      supplier_multi_loc_id: $supplier_multi_loc_id
      user_details: $user_details
    )
  }
`;

export const DeleteSupplier = gql`
  mutation DeleteSupplier(
    $token: String!
    $customer_id: ID!
    $supplier_ids: [ID!]!
    $user_details: SubscribedUser!
  ) {
    DeleteSupplier(
      token: $token
      customer_id: $customer_id
      supplier_ids: $supplier_ids
      user_details: $user_details
    )
  }
`;



